import { useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Autocomplete,
  Grid,
  TextField,
} from "../../../../../components";
import { IdentificarClienteDialogContent } from "../..";
import { InputErros, ValidarCpfCnpjHelper } from "../../../../../helpers";
import {
  ContasReceberService,
  notification,
  PessoaService,
} from "../../../../../services";
import { montarFiltroPessoa, responseErros } from "../../../../../utils";

export default function IdentificarClienteDialog({
  open,
  setOpen,
  clienteList,
  setClienteList,
  setClienteSelecionado,
  setListaNotasCredito,
  pdvEntity,
  setVenda,
  buscarClienteOffLine,
  pdvOnLine,
}) {
  const inputCliente = useRef();
  const [clienteAvulso, setClienteAvulso] = useState({});
  const [cliente, setCliente] = useState({});
  const [inputErro, setInputErro] = useState([]);
  //service fora do componente
  const validarCpfCnpjHelper = new ValidarCpfCnpjHelper();
  const contasReceberService = new ContasReceberService();
  const pessoaService = new PessoaService();
  const inputErros = new InputErros(inputErro, setInputErro);

  const handleCloseDialog = () => {
    setCliente({});
    setClienteAvulso({});
    setClienteList([]);
    setOpen(false);
  };

  const handleAdicionarCliente = () => {
    if (cliente?.nomeRazaoSocial) {
      setClienteSelecionado(cliente);
      pdvEntity.setIdentificarCliente(cliente);
      setVenda(pdvEntity);
      handleCloseDialog();
    } else {
      if (
        clienteAvulso?.cnpjCpf === "" &&
        clienteAvulso?.naturezaSocial !== ""
      ) {
        inputErros.gerar("cnpjCpf");
        return notification.alertaGenericos(
          "Insira um documento para identificar o cliente",
        );
      } else if (clienteAvulso?.cnpjCpf) {
        const cpfValido =
          clienteAvulso.cnpjCpf?.length <= 11
            ? validarCpfCnpjHelper.cpf(clienteAvulso.cnpjCpf)
            : validarCpfCnpjHelper.cnpj(clienteAvulso.cnpjCpf);
        if (!cpfValido) {
          inputErros.gerar("cnpjCpf");
          return notification.alertaGenericos("Documento inválido");
        } else {
          setClienteSelecionado(clienteAvulso);
          pdvEntity.setIdentificarCliente(clienteAvulso);
          setVenda(pdvEntity);
          handleCloseDialog();
        }
      } else handleCloseDialog();
    }
    inputErros.limpar();
  };

  const onSearchChangePessoas = (event, tiposPessoaId) => {
    if (
      event.key === "Enter" &&
      inputCliente.current === document.activeElement
    ) {
      const filtros = montarFiltroPessoa(event.target?.value);
      buscarCliente(filtros, tiposPessoaId, setClienteList);
    }
  };

  const buscarCliente = async (filtros, tiposPessoaId, setClienteList) => {
    if (pdvOnLine) {
      await buscarClienteOnline(filtros, tiposPessoaId, setClienteList);
    } else {
      await buscarClienteOffLine(filtros, setClienteList);
    }
  };

  const buscarClienteOnline = async (
    filtros,
    tiposPessoaId,
    setClienteList,
  ) => {
    const filtro = {
      ...filtros,
      tiposPessoaId,
      nonPaginated: true,
      ativado: true,
      attributes: [
        "id",
        "codigo",
        "nomeRazaoSocial",
        "cnpjCpf",
        "email",
        "telefone",
        "celular",
      ],
      disabledInclude: true,
    };
    pessoaService.getAll(filtro).then((res) => {
      if (!res.isAxiosError) {
        setClienteList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarNotasCredito = (pagadorId) => {
    const filtro = {
      pagadorId,
      tipo: "NOTA_CREDITO",
      status: ["ABERTO", "BAIXADO_PARCIAL"],
      restritiva: true,
    };
    contasReceberService.getAllFiltroAvancado(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaNotasCredito(result.data.rows);
      } else responseErros(result);
    });
  };

  const handleChangeInput = (value) => {
    if (pdvOnLine) {
      buscarNotasCredito(value?.id);
    }
    setCliente(value ? value : null);
    setClienteAvulso(value ? value : null);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      PaperComponent="div"
      open={open}
      aria-labelledby="form-dialog-title"
      onClose={handleCloseDialog}
    >
      <DialogContent>
        <Card className="p-3">
          <CardHeader title="Identificar Cliente" />
          <CardContent className="p-3">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  id="clienteId"
                  name="clienteId"
                  options={clienteList}
                  autoHighlight
                  fullWidth
                  getOptionLabel={(option) => {
                    let label = option?.nomeRazaoSocial || "";
                    if (option?.codigo) {
                      label = `${option.codigo} - ` + label;
                    }
                    return label;
                  }}
                  loadingText="Carregando"
                  noOptionsText={
                    document.getElementById("clienteId")?.value.length >= 1
                      ? "Nenhum cliente encontrado"
                      : "Digite e pressione Enter"
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Buscar Cliente"
                      error={inputErros.get("clienteId")}
                      variant={"outlined"}
                      onKeyDown={(e) => onSearchChangePessoas(e, 1)}
                      inputRef={inputCliente}
                      InputProps={{
                        ...params.InputProps,
                      }}
                    />
                  )}
                  onChange={(_, newValue) => handleChangeInput(newValue)}
                  value={cliente}
                />
              </Grid>
              <Grid item xs={12}>
                <hr></hr>
              </Grid>
              <Grid item xs={12}>
                <IdentificarClienteDialogContent
                  cliente={cliente}
                  clienteAvulso={clienteAvulso}
                  setClienteAvulso={setClienteAvulso}
                  inputErros={inputErros}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button
              type="submit"
              variant="contained"
              disableElevation
              onClick={(event) => handleAdicionarCliente(event)}
            >
              <i
                className="ph-fill ph-check-circle"
                style={{ color: "white", fontSize: 22, marginRight: 10 }}
              ></i>
              Salvar
            </Button>
            <Button
              color="inherit"
              variant="contained"
              disableElevation
              onClick={handleCloseDialog}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              />
              Fechar
            </Button>
          </CardActions>
        </Card>
      </DialogContent>
    </Dialog>
  );
}
